




































































































import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import StringUtils from '@/helpers/stringUtils';
import {
  isWaitingClient,
  isWaitingEmede,

  isWaitingPharmaceuticalApprove, isWaitingTranscription
} from '@/helpers/validatePrescriptionStatus';
import { JsonException } from '@/interfaces/base-dto';
import { AprovacaoAgendadaMultiParmDTO } from '@/interfaces/prescription';
import { AprovacaoTranscricaoParmDTO } from '@/interfaces/transcription';
import { getReasons } from '@/services/parameters';
import * as service from '@/services/prescription';
import { getLocalUser } from '@/services/session-data';
import { PrescriptionValidation } from '@/settings/consts/prescription-validation';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import AdvanceProductionDialog from './advance-production-dialog.vue';
import AlterPrescriptionDialog from './alter-prescription-dialog.vue';
import PrescriptionApprovalScheduleModal from './approval-schedule-modal.vue';
import PrescriptionApprovalScheduleMultiModal from './approval-schedule-multi-modal.vue';
import CancelPrescriptionDialog from './cancel-prescription-dialog.vue';
import DelayedProductionDialog from './delayed-production-dialog.vue';
import LockPrescriptionDialog from './lock-prescription-dialog.vue';
import UnlockPrescriptionDialog from './unlock-prescription-dialog.vue';

@Component({
  components: { 
    PermissionAuth,
    PrescriptionApprovalScheduleModal,
    PrescriptionApprovalScheduleMultiModal,
    CancelPrescriptionDialog,
    AlterPrescriptionDialog,
    LockPrescriptionDialog,
    UnlockPrescriptionDialog,
    AdvanceProductionDialog,
    DelayedProductionDialog
  },
})
export default class PrescriptionFormUpdateStatus extends BaseComponent {  
  @Prop()
  public item: any;

  @Prop()
  public prescriptionState: any;

  @Prop()
  public validationError?: boolean;
  
  @Prop()
  public visualizing?: boolean;

  @Prop({default: false})
  public isToCancel: boolean;

  public rules: any = {
    reason: [(v) => (!!v && !!v.id) || 'Selecione um motivo'],
  };

  public opcaoExcluir: boolean = false;
  public form: any = {
    valid: false,
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public reason: any = {};
  public reasons: any[] = [];

  public currentUserId: string = null;
  private botaoSufixoQtde:string = "";

  modalOpenApprovalSchedule = false;
  approvalScheduleEdit = false;
  showCancelDialog = false;
  showAlterDialog = false;
  showLockDialog = false;
  showUnlockDialog = false;
  showAdvanceProductionDialog = false;
  showDelayedProductionDialog = false;

  public beforeMount(): void {
    const filter = {
      idMedico: this.item.medico.id,
      idUnidade: this.item.unidade.id,
    };

    getLocalUser().subscribe((currentUser) => {
      this.currentUserId = currentUser.idLogin;
    });

    getReasons(filter).subscribe((data) => {
      this.reasons = data.valores || [];
    });
  }

  @Watch('item')
  onItemChange(n, o) {
    this.item.functionCallbackAfterSetRegister = null;
  }

  @Watch('item.registro')
  onRegisterChange(n, o) {
    if (!n || !!o || !this.item.functionCallbackAfterSetRegister) {
      return;
    }

    this.item.functionCallbackAfterSetRegister();
    this.item.functionCallbackAfterSetRegister = null;
  }
  
  private getLabelBotaoQtdePresc() {
    if (this.item && this.item.quantidade && this.item.quantidade > 1) {
      return ` ( ${this.item.quantidade} Prescrições )`;
    }
    return '';
  }

  public isImpeditive(): boolean {
    return this.prescriptionState === PrescriptionValidation.IMPEDITIVE.key;
  }

  public isLoading(): boolean {
    return this.prescriptionState === PrescriptionValidation.LOADING.key;
  }

  public isInvalid(): boolean {
    return this.prescriptionState === PrescriptionValidation.INVALID.key;
  }

  public prepareSaveStatus() {
    if (!isWaitingEmede(this.item.statusPrescricao)) {
      this.onSaveStatus();
      return;
    }
    this.loader.start('Preparando...');
    service.validatePreapproval(this.item.idPrescricao).subscribe(res => {
      this.loader.stop();
      this.onSaveStatus();
    }, error => {
      this.loader.stop();
      if (this.proccessErrorPrescricaoRegistroInvalidoException(error)) {
        this.item.invalidRegisterMsg = "Informe o registro para continuar com a Aprovação"
        this.item.functionCallbackAfterSetRegister = this.onSaveStatus;
        return;
      }
      this.showToastApiError(error);
    });
  }

  public onSaveStatus(): void {

    const updateAction = (ok, justification) => {
      this.loader.start('Atualizando status...');

      const observable = this.resolveApprovalStream(this.item, justification);

      const onError = (error) => {
        this.loader.stop();
        if (this.proccessErrorPrescricaoRegistroInvalidoException(error)) {
          return;
        }
        this.showToastApiError(error);
      };

      observable.subscribe((data) => {
        this.loader.stop();
        this.$emit('update');
      }, onError);
    };

    let msg = 'Deseja realmente aprovar esta prescrição?';
    let title = 'Aprovar prescrição'
    let tpDialog:any = 'alert';
    let btnTxtOk = 'Aprovar';
    let btnTxtCancel = 'Voltar';
    let maxWidth = null;
    let btnOkColor = null;
    let btnCancelColor = null;
    let btnSolid = false;
    let showJustify = false;
    let justifyTitle = "";
    let justifyPlaceholder = "";
    if (this.item.permissao.checkCienteAdiantAprovacao) {
     this.doShowAdvanceProductionDialog();
     return;
    } else if (this.item.permissao.showAprovacaoAlertaHorarioLimite) {
      this.doShowDelayedProductionDialog();
      return;
    }

    this.dialog.show(
      tpDialog,
      title,
      msg,
      btnTxtOk,
      updateAction,
      btnTxtCancel,
      '',
      null,
      maxWidth,
      btnOkColor,
      btnCancelColor,
      btnSolid,
      showJustify,
      justifyTitle,
      justifyPlaceholder
    );
  }
  

  public onScheduleProduction(edit) {
    this.loader.start('Preparando...');
    service.validatePreapproval(this.item.idPrescricao).subscribe(res => {
      this.approvalScheduleEdit = edit;
      this.loader.stop();
      this.modalOpenApprovalSchedule = true;
    }, error => {
      this.loader.stop();
      if (this.proccessErrorPrescricaoRegistroInvalidoException(error)) {
        this.item.invalidRegisterMsg = "Informe o registro para continuar com a Aprovação e Agendamento"
        this.item.functionCallbackAfterSetRegister = this.onScheduleProduction;
        return;
      }
      this.showToastApiError(error);
    });
  }

  public saveScheduleProduction(horario, ids) {
    this.loader.start('Aprovando e agendando...');
    service.emedeAprovationSchedule(ids, horario).subscribe( r => {
      this.modalOpenApprovalSchedule = false;
      this.loader.stop();
      this.$emit('update');
    }, (error) => {      
      this.loader.stop();
      if (this.proccessErrorPrescricaoRegistroInvalidoException(error)) {
        return;
      }
      this.showToastApiError(error);
    });
  }

  public saveScheduleProductionMulti(parm: AprovacaoAgendadaMultiParmDTO) {
    this.loader.start('Aprovando e agendando...');
    service.emedeAprovationScheduleMulti(parm).subscribe( r => {
      this.modalOpenApprovalSchedule = false;
      this.loader.stop();
      this.$emit('update');
    }, (error) => {      
      this.loader.stop();
      if (this.proccessErrorPrescricaoRegistroInvalidoException(error)) {
        return;
      }
      this.showToastApiError(error);
    });
  }

  proccessErrorPrescricaoRegistroInvalidoException(error):boolean {
    if (StringUtils.isValidJSONString(error.data.message)) {
      let obj:JsonException = JSON.parse(error.data.message);
      if (obj.className && obj.className == 'PrescricaoRegistroInvalidoException') {
        this.$emit('invalidRegisterValue');
        return true;
      }
    } 
    return false;
  }

  public prescribeCopy(editable:boolean) {
    this.$emit('prescribeCopy', editable, this.item);      
  }

  public onAlterPrescription(ids, dates, idReason) {
    this.onCloseAlterDialog();
    this.$emit('alterPrescription', ids, dates, idReason, this.item);
  }

  public openFormRecusar(excluir: boolean = false): void {
    this.opcaoExcluir = excluir;
    this.showCancelDialog = true;
  }

  public onCloseCancelDialog(){
    this.showCancelDialog = false;
  }

  public onSaveCancelDialog() {
    this.$emit('update');
    this.showCancelDialog = false;
  }

  public openFormAlter() {
    this.showAlterDialog = true;
  }

  public onCloseAlterDialog() {
    this.showAlterDialog = false;
  }

  private resolveApprovalStream(item: any, justification?: string) {
    if (isWaitingEmede(item.statusPrescricao)) {
      return service.emedeAprovation(item.idPrescricao, justification);
    }

    if (isWaitingClient(item.statusPrescricao)) {
      return service.clientAprovation(item.idPrescricao);
    }

    if (
      isWaitingTranscription(item.statusPrescricao) ||
      isWaitingPharmaceuticalApprove(item.statusPrescricao)
    ) {
      let parm = new AprovacaoTranscricaoParmDTO();
      parm.idPrescricao = this.item.idPrescricao;
      parm.idTranscricao = this.item.idPrescricao;
      parm.justifProducaoAdiantada = justification;
      return service.transcriptionPrescriptionAprovation(parm);
    }

    return;
  }

  onCloseApprovalScheduleModal() {
    this.modalOpenApprovalSchedule = false;
  }

  public openLockDialog() {
    this.showLockDialog = true;
  }

  public onCloseLockDialog() {
    this.showLockDialog = false;
  }

  public onLockPrescription() {
    this.showLockDialog = false;
    this.$emit('update');
  }

  public openUnlockDialog() {
    this.showUnlockDialog = true;
  }

  public onCloseUnlockDialog() {
    this.showUnlockDialog = false;
  }

  public onUnlockPrescription() {
    this.showUnlockDialog = false;
    this.$emit('update');
  }

  @Watch('isToCancel', {immediate: true})
  public onChangeIsToCancel(isToCancel) {
    if (!isToCancel) {
      return;
    }

    this.sleepUntil(() => {
      return this.item && this.item.permissao;
    }, 15000).then( () => {
      setTimeout(() => {
        if (!this.item.permissao.usuarioPodeExcluir) {
          return;
        }
        this.openFormRecusar(true);        
      }, 1000);
    })
  }

  doShowAdvanceProductionDialog() {
    this.showAdvanceProductionDialog = true;
  }

  onCancelAdvanceProductionDialog() {
    this.showAdvanceProductionDialog = false;
  }

  onConfirmAdvanceProductionDialog(justification, newDeliveryDate) {
    this.loader.start('Processando...');
    service.emedeAprovation(this.item.idPrescricao, justification, newDeliveryDate).subscribe(res => {
      this.showAdvanceProductionDialog = false;
      this.loader.stop();
      this.$emit('update');
    }, error => {
      this.loader.stop();
      if (this.proccessErrorPrescricaoRegistroInvalidoException(error)) {
        return;
      }
      this.showToastApiError(error);
    })
  }

  doShowDelayedProductionDialog() {
    this.showDelayedProductionDialog = true;
  }

  onCancelDelayedProductionDialog() {
    this.showDelayedProductionDialog = false;
  }

  onConfirmDelayedProductionDialog() {
    this.loader.start('Processando...');
    this.resolveApprovalStream(this.item).subscribe(res => {
      this.showDelayedProductionDialog = false;
      this.loader.stop();
      this.$emit('update');
    }, error => {
      this.loader.stop();
      if (this.proccessErrorPrescricaoRegistroInvalidoException(error)) {
        return;
      }
      this.showToastApiError(error);
    })
  }

}
